<template>
  <p>
    <DiceItem :label="defenseLabel" :dice="defense"></DiceItem>
    <br />
    <ArmorItem :armor="armor"></ArmorItem>
  </p>
</template>

<script>
import DiceItem from "./DiceItem";
import ArmorItem from "./ArmorItem";
export default {
  name: "DefenseBlock",
  components: { ArmorItem, DiceItem },
  props: {
    defense: {
      type: Object,
      required: true
    },
    armor: { type: Number, required: true }
  },
  data() {
    return {
      defenseLabel: "Defense"
    };
  }
};
</script>
